/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';
import DisplayAmountWithDecimals from "../../shared/DisplayAmountWithDecimals";

const CloseTicketConfirmationModal: React.FC<{
    dataToProcess: any;
    isOpen: boolean;
    onClose(): void;
    setSwalProps: any;
}> = ({ isOpen, onClose, dataToProcess, setSwalProps }) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [resolutionNotes, setResolutionNotes] = useState<string>("");
    const userRole = localStorage.getItem("userRole");

    const closeModal = async () => {
        setResolutionNotes("");
        onClose();
    };

    const handleSubmit = async () => {
        try {
            setIsProcessing(true);

            const data = {
                username: localStorage.getItem("username"),
                userRole: userRole,
                id: dataToProcess.id,
                subaccount_id: dataToProcess.subaccount.id,
                status: "closed"
            }

            await axios.post(process.env.REACT_APP_API_URL + `/api/${userRole.toLowerCase()}/trade/action/update-trade-conversation-status`, data)
                .then(function (response) {
                    if (response && response.data?.status === 'ok') {
                        closeModal();
                        setSwalProps({
                            show: true,
                            icon: "success",
                            title: "Success",
                            html: "Ticket has been closed",
                            showConfirmButton: true,
                            didClose: () => {
                                setSwalProps({});
                                setIsProcessing(false);
                            },
                        });
                    } else {
                        setIsProcessing(false);
                    }
                })
                .catch(function (error) {
                    setIsProcessing(false);
                    setSwalProps({
                        show: true,
                        icon: "error",
                        title: "Oops!",
                        html: error.response.data.message,
                        showConfirmButton: true,
                        didClose: () => {
                            setSwalProps({});
                            setIsProcessing(false);
                        },
                    });
                });
        } catch (error: any) {
            setIsProcessing(false);
            setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: "Something went wrong, please try again later.",
                showConfirmButton: true,
                didClose: () => {
                    setSwalProps({});
                    setIsProcessing(false);
                },
            });
        }
    };

    const formatAddress = (address?: string): string => {
        if (!address || address.length < 24) return 'N/A';
        return `${address.slice(0, 15)}...${address.slice(-9)}`;
    };

    return (
        <>
            {dataToProcess &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]">
                        <ModalBody className="!text-navy-700">
                            <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004]">
                                <h1 className="mb-[20px] text-2xl font-bold">Close Ticket Confirmation</h1>
                                <div className="mb-[20px] text-sm">
                                    <div className="mb-8">
                                        You're about to close this conversation ticket. This action cannot be undone.
                                    </div>
                                    <div className="mb-1">
                                        <span>Code:</span>
                                        <span className="ml-3 font-semibold">{dataToProcess.shortid}</span>
                                    </div>
                                    {userRole === "superadmin" &&
                                        <div className="mb-1">
                                            <span>Subaccount:</span>
                                            <span className="ml-3 font-semibold">{dataToProcess.subaccount.name}</span>
                                        </div>
                                    }
                                    <div className="mb-1">
                                        <span>Pair:</span>
                                        <span className="ml-3 font-semibold">{`${dataToProcess.from_asset}/${dataToProcess.to_asset} (${dataToProcess.to_network})`}</span>
                                    </div>
                                    <div className="mb-1">
                                        <span>Amount:</span>
                                        <span className="ml-3 font-semibold"><DisplayAmountWithDecimals amount={Number(dataToProcess.from_amount)} currency={dataToProcess.from_asset} decimal={dataToProcess?.from_asset_decimal} /> {dataToProcess.from_asset}</span>
                                    </div>
                                    {dataToProcess.from_network === "fiat" &&
                                        <div className="mb-1">
                                            <span>To Address:</span>
                                            <span className="ml-3 font-semibold">
                                                {`${dataToProcess.to_address.nickname} (${formatAddress(dataToProcess.to_address.address)})`}
                                            </span>
                                        </div>
                                    }
                                    <div className="mb-1">
                                        <span>Ref.</span>
                                        <span className="ml-3 font-semibold">
                                            {dataToProcess.reference}
                                        </span>
                                    </div>
                                </div>
                                <div className="flex gap-2 justify-end">
                                    <Button
                                        onClick={() => closeModal()}
                                        isDisabled={isProcessing}
                                        className="btn btn-default"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={() => handleSubmit()}
                                        isLoading={isProcessing}
                                        loadingText='Closing...'
                                        className="btn text-white bg-red-600 hover:bg-red-500">
                                        Close Ticket
                                    </Button>
                                </div>
                            </Card>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default CloseTicketConfirmationModal;